<template>
  <UiBadge
    :content="count"
    color="sidebar-badge-bg-color"
    text-color="sidebar-badge-text-color"
    class="ui-list-item-badge"
    inline
  />
</template>

<script setup lang="ts">
import { UiBadge } from '~/ui';

export interface Props {
  count: string;
}
defineProps<Props>();
</script>

<style lang="scss" scoped>
.ui-list-item-badge :deep(.v-badge__badge) {
  height: 100%;
}

.ui-list-item-badge :deep(.v-badge__wrapper) {
  margin: 0;
}
</style>
